/**
 * Creates a `li` element to be used a Bootstrap 4 carousel indicator.
 *
 * @param {number} index
 *   The index for this indicator, used to track which carousel item it is
 *   assigned too,
 *
 * @return {HTMLLIElement}
 *   The carousel indicator element.
 */
function createCarouselIndicator(index) {
  // Generate the carousel indicator item.
  const li = document.createElement('li');
  // Create the attributes the assign the indicator to a slide. This is
  // based on the slide's index in the array.
  const attrs = {
    'data-target': '#slideshow-block',
    'data-slide-to': index,
  };
  // Set the first item as active.
  if (index === 0) {
    attrs.class = 'active';
  }
  // Add the attributes to the indicator
  Object.keys(attrs).forEach((attr) => {
    li.setAttribute(attr, attrs[attr]);
  });

  return li;
}

/**
 * Create the carousel's indicators and add them to the DOM.
 */
Drupal.behaviors.createCarouselIndicators = {
  attach: (context) => {
    once(
      'carousel-indicators',
      '#slideshow-block .view-content',
      context,
    ).forEach((element) => {
      // Create carousel indicators container.
      const ol = document.createElement('ol');
      // Define the carousel indicator class.
      ol.setAttribute('class', 'carousel-indicators');
      // For every carousel item available generate an indicator for navigating
      // between the slides.
      $('.carousel-item', context).each((i) => {
        // Append the indicator to the indicator container.
        ol.appendChild(createCarouselIndicator(i));
      });

      $(element).prepend(ol);
    });
  },
};

/**
 * Set the first carousel item as active.
 */
Drupal.behaviors.firstCarouselItem = {
  attach: (context) => {
    const carouselItems = once(
      'first-carousel-item',
      '.carousel-item',
      context,
    );

    if (carouselItems.length) {
      $(carouselItems[0]).addClass('active');
    }
  },
};

/**
 * Initialize slideshow on elements with the class `.carousel`.
 */
Drupal.behaviors.initializeCarousel = {
  attach: (context) => {
    once('slideshow-block', '#slideshow-block', context).forEach(
      (slideshow) => {
        $(slideshow).carousel({
          interval: 5000,
          touch: true,
        });
      },
    );
  },
};

/**
 * Initialize the carousel buttons.
 *
 * Since we can't get an ID to our carousel, our own click actions are
 * required.
 */
Drupal.behaviors.initializeCarouselButtons = {
  attach: (context) => {
    once(
      'carousel-buttons',
      '.carousel-control-prev, .carousel-control-next',
      context,
    ).forEach((button) => {
      $(button).on('click', (event) => {
        event.preventDefault();
        // Fetch the item that was clicked.
        const $item = $(event.currentTarget);
        // The action, prev or next, is in a data attribute.
        const action = $item.attr('data-slide');
        // Move to the previous or next slideshow item depending on which button
        // was clicked.
        $('.carousel').carousel(action);
      });
    });
  },
};
